import ModalHeader from './ModalHeader.react';
var Modal = function Modal(_ref) {
  var title = _ref.title,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: title
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body"
  }, children));
};
export default Modal;